var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H8C9.10457 2 10 2.89543 10 4V12.5H7.99999C6.067 12.5 4.49999 14.067 4.49999 16V18H4C2.89543 18 2 17.1046 2 16V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.25C12.5858 3.25 12.25 3.58579 12.25 4C12.25 4.41421 12.5858 4.75 13 4.75C15.3472 4.75 17.25 6.65279 17.25 9V9.18934L15.5303 7.46967C15.2374 7.17678 14.7626 7.17678 14.4697 7.46967C14.1768 7.76256 14.1768 8.23744 14.4697 8.53033L17.4697 11.5303C17.5416 11.6022 17.6245 11.6565 17.7129 11.6931C17.7901 11.7251 17.8738 11.7446 17.9614 11.749C17.9742 11.7497 17.9871 11.75 18 11.75C18.1017 11.75 18.1987 11.7298 18.2871 11.6931C18.3755 11.6565 18.4584 11.6022 18.5303 11.5303L21.5303 8.53033C21.8232 8.23744 21.8232 7.76256 21.5303 7.46967C21.2374 7.17678 20.7626 7.17678 20.4697 7.46967L18.75 9.18934V9C18.75 5.82436 16.1756 3.25 13 3.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14C21.1046 14 22 14.8954 22 16V20C22 20.6745 21.6661 21.2711 21.1545 21.6333C21.1216 21.5747 21.0802 21.5196 21.0303 21.4697L17.0303 17.4697C16.7374 17.1768 16.2626 17.1768 15.9697 17.4697L13.75 19.6893L10.5303 16.4697C10.2374 16.1768 9.76256 16.1768 9.46967 16.4697L6 19.9393V16C6 14.8954 6.89543 14 8 14H20Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.0607L19.4393 22H16.059C16.0498 21.9897 16.0402 21.9796 16.0303 21.9697L14.8107 20.75L16.5 19.0607Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9393 22L10 18.0607L6.61644 21.4442C6.97569 21.7885 7.46314 22 8 22H13.9393Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.cdf297347771f89a77c6bea685f811c9.svg";
export { ForwardRef as ReactComponent };